import { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import useGetShopEmbedHtmlSuspense from "@babackapp/private-api-client/client/use-get-embed-content";
import type { EmbedContent } from "@babackapp/private-api-client/generated/schema";

const DEV_EMBED_URL = "http://localhost:5175/index.js";

export default function EmbedPage() {
  const [searchParams] = useSearchParams();
  const shopifyUrl = searchParams.get("shop");

  if (!shopifyUrl) {
    throw new Error("shop param is required");
  }

  const { data } = useGetShopEmbedHtmlSuspense(shopifyUrl, true);
  const shopId = data.shopId;

  if (!shopId) return null;

  return (
    <>
      <EmbedScriptRunner embedData={data} shopId={shopId} />
      <div dangerouslySetInnerHTML={{ __html: data.html }} />
    </>
  );
}

function EmbedScriptRunner({
  embedData,
  shopId,
}: {
  embedData: EmbedContent;
  shopId: string;
}) {
  const widgetPosition = embedData.widgetPosition ?? "center";

  useEffect(() => {
    console.log("[baback] EmbedScriptRunner effect", { widgetPosition, embedScriptUrl: embedData.embedScriptUrl, existingScript: !!document.querySelector("script[data-shop-id]") });
    if (document.querySelector("script[data-shop-id]")) return;

    const embedSrc = import.meta.env.DEV ? DEV_EMBED_URL : embedData.embedScriptUrl;
    console.log("[baback] embedSrc", embedSrc);

    if (!embedSrc) {
      const scriptFn = new Function(embedData.script);
      scriptFn();
      return;
    }

    const s = document.createElement("script");
    s.src = embedSrc;
    s.setAttribute("data-shop-id", shopId);
    s.setAttribute("data-base", window.location.origin);
    s.setAttribute("data-auto-open", "true");
    s.setAttribute("data-position", widgetPosition);
    s.setAttribute("data-advanced", "true");
    s.async = true;
    document.head.appendChild(s);
  }, [embedData, shopId, widgetPosition]);

  return null;
}
